import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '@/locales/en/common.json';
import enPatients from '@/locales/en/patients.json';
import enSubjects from '@/locales/en/subjects.json';
import enSites from '@/locales/en/sites.json';
import enProcedures from '@/locales/en/procedures.json';
import enErrors from '@/locales/en/errors.json';
import enAssessments from '@/locales/en/assessments.json';
import enAuth from '@/locales/en/auth.json';
import enEligibilityChecklist from '@/locales/en/eligibilityChecklist.json';
import enCockpit from '@/locales/en/cockpit.json';
import enConsents from '@/locales/en/consents.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    patients: enPatients,
    subjects: enSubjects,
    sites: enSites,
    procedures: enProcedures,
    errors: enErrors,
    assessments: enAssessments,
    auth: enAuth,
    eligibilityChecklist: enEligibilityChecklist,
    cockpit: enCockpit,
    consents: enConsents,
  },
};

export const ns = [
  'common',
  'patients',
  'subjects',
  'sites',
  'errors',
  'assessments',
  'auth',
  'eligibilityChecklist',
  'procedures',
  'cockpit',
  'consents',
];

i18next
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns,
    defaultNS,
    resources,
  })
  .catch((error: unknown) => {
    console.error('i18next initialization failed', error);
  });
